import { render, staticRenderFns } from "./my-response.vue?vue&type=template&id=0536adfe&scoped=true&"
import script from "./my-response.vue?vue&type=script&lang=js&"
export * from "./my-response.vue?vue&type=script&lang=js&"
import style0 from "./my-response.vue?vue&type=style&index=0&id=0536adfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536adfe",
  null
  
)

export default component.exports